export const generateUrlParams = (obj) => {
	let generatedUrl = ``;
	const arrayOfObjectKeys = Object.keys(obj);
	arrayOfObjectKeys.forEach((key) => {
		if (obj[key] || obj[key] === false) {
			generatedUrl += `${key}=${obj[key]}&`;
		}
	});
	return generatedUrl;
};
